import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import Button from '../../../components/atoms/inputs/Button'
import { FlexColumn, FlexRow } from '../../../components/atoms/layout/Flex'
import { CompanyActions } from '../../../store/company'
import { CompanySelectors } from '../../../store/company/selectors'
import VisitorRegistrationWorkerTable from '../../../components/organisms/visitor/registration/worker/Table'
import Alert from '../../../components/atoms/feedback/Alert'
import { useVisitorRegistrationFormWorkerCreateDialog } from '../../../hooks/useDialog'

export function VisitorRegistrationFormWorkersPage() {
  const dispatch = useDispatch()
  const form = useSelector(CompanySelectors.visitorRegistrationForm)
  const workers = useSelector(CompanySelectors.visitorRegistrationFormWorkers)
  const workerCreateDialog = useVisitorRegistrationFormWorkerCreateDialog()

  useEffect(() => {
    dispatch(CompanyActions.fetchVisitorRegistrationForm())
    dispatch(CompanyActions.fetchVisitorRegistrationFormWorkers())
  }, [dispatch])

  if (!form) {
    return (
      <FlexColumn>
        <Alert severity="error">事業者情報を設定してください</Alert>
      </FlexColumn>
    )
  }

  return (
    <FlexColumn>
      <FlexRow>
        <Button onClick={() => workerCreateDialog.open()}>新規登録</Button>
      </FlexRow>
      {workers.length === 0 ? (
        <Alert label="労働者情報は登録されていません" severity="info" />
      ) : (
        <VisitorRegistrationWorkerTable workers={workers} />
      )}
    </FlexColumn>
  )
}
